
import { Component, Emit, Model, Prop, Vue, Watch } from 'nuxt-property-decorator';
import { type NestedPage, PageType } from '../../../services/fourwaves/models';
import Simplebar from 'simplebar-vue';
import BurgerBtn from '../../blocks/BurgerBtn.vue';
import WebsiteMobileNavigationLink from '../navigation/WebsiteMobileNavigationLink.vue';
import WebsiteMobileNavigationDropdown from '../navigation/WebsiteMobileNavigationDropdown.vue';
import { v4 as uuid } from 'uuid';

@Component({
  components: {
    BurgerBtn,
    Simplebar,
    WebsiteMobileNavigationLink,
    WebsiteMobileNavigationDropdown,
  },
})
export default class WebsiteMobileNavigation extends Vue {
  @Prop({ type: Array, default: () => [] }) nestedPages!: NestedPage[];

  @Emit('change') emitChange(value: boolean) {
    return value;
  }

  @Model('change', { type: Boolean, required: false }) readonly value!: boolean;

  readonly PageType = PageType;

  uniqueId = uuid();

  get innerValue(): boolean {
    return this.value;
  }

  set innerValue(value: boolean) {
    this.$emit('change', value);
  }

  @Watch('$route')
  onRoutechange() {
    this.$nextTick(() => setTimeout(() => (this.innerValue = false), 50));
  }
}
